var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{attrs:{"link":"","disabled":!_vm.permission},on:{"click":_vm.onCapture}},[_c('v-list-item-title',[_vm._v(" Screenshot ")]),_c('v-list-item-icon',[_c('v-icon',[_vm._v("mdi-monitor-screenshot")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }